var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"reservationList"},[_c('list',{attrs:{"queryType":"11","listItemConfig":_vm.listItemConfig},on:{"toDetail":_vm.toDetail}}),_c('detailPopup',{ref:"detailPopup"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }